export default class TrackTooltipShown {
  constructor(context) {
    this.context = context;
  }

  run({ customerId }) {
    let numMatches = 0;
    let activeCall = this.context.stores.activeCall.get();

    if (this.context.stores.customers.has({ id: customerId })) {
      const customersStores = this.context.stores.customers.storesFor(customerId);
      numMatches = customersStores.customerMatch.get() && customersStores.customerMatch.get().profiles.length;
    }
    this.context.analytics.track('Customer Match Tooltip Shown', {
      customerId,
      numMatches,
      hasActiveCall: !!activeCall,
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer_match/track_tooltip_shown.js